module.exports = __webpack_public_path__ + "static/c12-2244fd97b7c4c31134ed4c3a8a3c3d72.png";